import React, { FC } from 'react';

import { Container, Title, Button, Icon } from './styles';
import { Props } from './types';

const Placeholder: FC<Props> = ({
  message,
  buttonCaption,
  disabled,
  onClick,
}) => {
  return (
    <Container>
      <Icon />
      <Title>{message}</Title>
      <Button size="big" disabled={disabled} onClick={onClick} type="button">
        {buttonCaption}
      </Button>
    </Container>
  );
};

export default Placeholder;

// TODO: TFR-29 add story to component
